export function useTrackEvent() {
  return (useNuxtApp() as any).$trackEvent
}
